const stageserviceId = "fsxlndcy";
const stagesecret = "exwnnrxk";
const productionserviceId = "fpfzhezd";
const productionsecret = "ymxdioxw";
const host = document.location.host;
const protocol = window.location.protocol;
const localBase = `${protocol}//${host}`;
const isLocal =
  host.includes('localhost') ||
  host.startsWith('127.') ||
  host.startsWith('10.') ||
  host.startsWith('192.168.');
const stagehost = 'stagetoolkit.i-scream.co.kr';
const productionhost = 'toolkit.i-scream.co.kr';
const testproductionhost = 'testtoolkit.i-scream.co.kr';

const local_app_callback_uri = `${localBase}/apps/appbridge.html?v=${__APP_VERSION__}`;
const stage_app_callback_uri = `https://stagetoolkit.i-scream.co.kr/apps/appbridge.html?v=${__APP_VERSION__}`;
const production_app_callback_uri = `https://toolkit.i-scream.co.kr/apps/appbridge.html?v=${__APP_VERSION__}`;
const testproduction_app_callback_uri = `https://testtoolkit.i-scream.co.kr/apps/appbridge.html?v=${__APP_VERSION__}`;

const local_app_login_url = `${localBase}/apps/apptlogin.html?v=${__APP_VERSION__}`;
const stage_app_login_url = `https://stagetoolkit.i-scream.co.kr/apps/apptlogin.html?v=${__APP_VERSION__}`;
const production_app_login_url = `https://toolkit.i-scream.co.kr/apps/apptlogin.html?v=${__APP_VERSION__}`;
const testproduction_app_login_url = `https://testtoolkit.i-scream.co.kr/apps/apptlogin.html?v=${__APP_VERSION__}`;

const stageLoginCheckUrl = 'https://stageoauth2client.i-screammedia.com/loginCheck';
const productionLoginCheckUrl = 'https://oauth2client.i-screammedia.com/loginCheck';

const stageLoginUrl = 'https://stageoauth2client.i-screammedia.com/oauth2/authorization/iScream';
const productionLoginUrl = 'https://oauth2client.i-screammedia.com/oauth2/authorization/iScream';

let apploginCheckUrl;
let apploginUrl;
let appCallbackUrl;

if(isLocal){
  
  apploginCheckUrl = `${stageLoginCheckUrl}?serviceId=${stageserviceId}&secret=${stagesecret}&callback_uri=${local_app_callback_uri}`;
  apploginUrl = `${stageLoginUrl}?serviceId=${stageserviceId}&secret=${stagesecret}&lang=ko&mbtn=Y&ld=loginDirect&callback_uri=${local_app_callback_uri}&loginUrl=${local_app_login_url}&target=_blank&width=524&height=524`; //원래값은 680
  appCallbackUrl = local_app_callback_uri;

}else if(host == stagehost){
  
  apploginCheckUrl = `${stageLoginCheckUrl}?serviceId=${stageserviceId}&secret=${stagesecret}&callback_uri=${stage_app_callback_uri}`;
  apploginUrl = `${stageLoginUrl}?serviceId=${stageserviceId}&secret=${stagesecret}&lang=ko&mbtn=Y&ld=loginDirect&callback_uri=${stage_app_callback_uri}&loginUrl=${stage_app_login_url}&target=_blank&width=524&height=524`; //원래값은 680
  appCallbackUrl = stage_app_callback_uri;

}else if(host == productionhost){
  
  apploginCheckUrl = `${productionLoginCheckUrl}?serviceId=${productionserviceId}&secret=${productionsecret}&callback_uri=${production_app_callback_uri}`;
  apploginUrl = `${productionLoginUrl}?serviceId=${productionserviceId}&secret=${productionsecret}&lang=ko&mbtn=Y&ld=loginDirect&callback_uri=${production_app_callback_uri}&loginUrl=${production_app_login_url}&target=_blank&width=524&height=524`; //원래값은 680
  appCallbackUrl = production_app_callback_uri;

}else if(host == testproductionhost){
  
  apploginCheckUrl = `${productionLoginCheckUrl}?serviceId=${productionserviceId}&secret=${productionsecret}&callback_uri=${testproduction_app_callback_uri}`;
  apploginUrl = `${productionLoginUrl}?serviceId=${productionserviceId}&secret=${productionsecret}&lang=ko&mbtn=Y&ld=loginDirect&callback_uri=${testproduction_app_callback_uri}&loginUrl=${testproduction_app_login_url}&target=_blank&width=524&height=524`; //원래값은 680
  appCallbackUrl = testproduction_app_callback_uri;

}

export { apploginCheckUrl, apploginUrl, appCallbackUrl };